export default [
  {
    coregvId: 1,
    mobileARLink: "https://cloud.radiusmedia.de/conel/Plus/AR/COREGV1.html",
    androidModelLink:
      "https://cloud.radiusmedia.de/conel/Plus/model/COREGV1.glb",
    IOSModelLink: "https://cloud.radiusmedia.de/conel/Plus/model/COREGV1.usdz",
    ARCodeImg: "./img/product/qrcode/coregv1.png",
  },
  {
    coregvId: 2,
    mobileARLink: "https://cloud.radiusmedia.de/conel/Plus/AR/COREGV2.html",
    androidModelLink:
      "https://cloud.radiusmedia.de/conel/Plus/model/COREGV2.glb",
    IOSModelLink: "https://cloud.radiusmedia.de/conel/Plus/model/COREGV2.usdz",
    ARCodeImg: "./img/product/qrcode/coregv2.png",
  },
  {
    coregvId: 3,
    mobileARLink: "https://cloud.radiusmedia.de/conel/Plus/AR/COREGV3.html",
    androidModelLink:
      "https://cloud.radiusmedia.de/conel/Plus/model/COREGV3.glb",
    IOSModelLink: "https://cloud.radiusmedia.de/conel/Plus/model/COREGV3.usdz",
    ARCodeImg: "./img/product/qrcode/coregv3.png",
  },
  {
    coregvId: 4,
    mobileARLink: "https://cloud.radiusmedia.de/conel/Plus/AR/COREGV4.html",
    androidModelLink:
      "https://cloud.radiusmedia.de/conel/Plus/model/COREGV4.glb",
    IOSModelLink: "https://cloud.radiusmedia.de/conel/Plus/model/COREGV4.usdz",
    ARCodeImg: "./img/product/qrcode/coregv4.png",
  },
];
